export enum SPThemeVariables {
  borderRadiusSmall = "8px",
  borderRadiusSmallMedium = "12px",
  borderRadiusMedium = "14px",
  borderRadiusLarge = "16px",
  borderRadiusXLarge = "20px"
}
